/**
 * Capitalizes the first letter of each whitespace-separated word and leaves the rest of the word
 * alone: "air products helium" -> "Air Products Helium", while an all-caps word such as "AP" or
 * "NORTH" is left untouched.
 *
 * Used for scheduling team names in outgoing email: the names are stored exactly as they were typed,
 * so they can arrive all lowercase even though they read as proper nouns.
 */
export function capitalizeWords(value: string | null | undefined): string {
  if (!value) return "";

  return value.replace(/\S+/g, (word) => word.charAt(0).toUpperCase() + word.slice(1));
}
